import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as UserDataConfig from '../../../config/user-data.config';
import { Tooltip } from 'src/app/model/tooltip';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import { UnderWritingData, AnnuitantMedicalConditions } from '../../../model/lifestyle.post.model';
import { SyncService } from '../../../services/sync.service';
import { UtilService, SERVICE_END_POINT, QuoteDataCaptureService, AuthService } from 'src/app/shared';
import * as LifeStyleActions from '../../../store/actions/lifestyle.action';
import { MedCondDashBoard, CurrentMedConToDisplay, BackDataStoreModel, EditMedIndexModel } from '../../../model/mcUserJourney.model';
import { MedicalCondQuestionSet, MedicalDashboardStatus } from '../../../medical-underwrting.constants';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { UtilityServiceForMedicalService } from '../../../services/utility-service';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { AlertModal } from 'src/app/model/alert';
import { Observable } from 'rxjs/internal/Observable';
import { RefNo } from 'src/app/model/ngrx';
import * as RefNumberActions from '../../../../../store/actions/reference-number.actions';
import { AnalyticsService } from 'src/app/shared';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { DeviceDimensionsService } from 'src/app/shared/utilities/functionality/device-dimensions.service';

@Component({
  selector: 'app-medical-condition',
  templateUrl: './medical-condition.component.html',
  styleUrls: ['./medical-condition.component.scss']
})
export class MedicalConditionComponent implements OnInit {
  public contentData;
  public headerText: string;
  public notifStatement: string;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public userForm: UntypedFormGroup;
  public medicalConditionConfig: Tooltip;
  private lifeStyleFromStoreObsSubscription: Subscription;
  private selectedTitle: string;
  medCondListForDashboard: MedCondDashBoard[] = [];
  public isDataPresent = false;
  isHOView = false;
  private CMSData: any;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private lifeStylePayloadFromStoreObj: UnderWritingData;
  public deleteModalConfig: AlertModal;
  public skipModalConfig: AlertModal;
  public statusModalConfig: AlertModal;
  isDelete: boolean = false;
  itemToDelete: MedCondDashBoard;
  isSkip: boolean = false;
  private rangeValidationData: any;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  editMode: boolean;
  showModalForCardRefresh: boolean = false;
  screenName: string;
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  private eventType: string;
  public isIncomplete: boolean = false;
  private stagedDataToEdit: MedCondDashBoard;
  deviceType: any;
  public alertCardRefreshModalConfig: AlertModal = new AlertModal('alert', ' You have entered new information that may impact your quote', '', 'Continue', 'Discard changes', '');
  displayTooltipAlert: boolean = false;
  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router,
    private syncService: SyncService, private store: Store<AppState>,
    private utilService: UtilService, private healthService: HealthService,
    public utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private analyticsService: AnalyticsService, private authService: AuthService, private deviceDimensionsService: DeviceDimensionsService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.medicalCondition;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        // this.quoteRefNo = val[0]['quoteReferenceNumber'];
        if ((this.referenceNumber && this.referenceNumber.editMode) ||
          (this.referenceNumber && this.referenceNumber.isRefreshCard)) {
          this.editMode = true;
          if (this.referenceNumber && !this.referenceNumber.isRefreshCard) {
            this.userInputDetail['buttonConfig']['label'] = 'Done';
            this.userInputDetail['buttonConfig']['name'] = 'Done';
          }
          // this.personalFormEdit = JSON.parse(JSON.stringify(this.personDetail));
        } else {
          this.editMode = false;
        }
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.userFormData();
    // this.InitializeToolTipForHeader();
    this.getHeaderText();
    this.getNotificationText();
    this.getLifestyleRange();

    this.syncService.setEditMode(false);

    // this.deleteModalConfig = this.contentData.modalMCDeleteConfig;
    // this.skipModalConfig = this.contentData.modalMCSkipConfig;
    // this.statusModalConfig = this.contentData.modalStatusConfig;
    this.alertCardRefreshModalConfig.setContent(this.activatedRoute.snapshot.data.contentData.generalConstants.cardRefreshWarning);
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (res.length > 0) {
        this.lifeStylePayloadFromStoreObj = res[0];
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && this.lifeStylePayloadFromStoreObj?.annuitantMedicalConditions &&
          this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions.length > 0) {
          this.lifeStylePayloadFromStoreObj = { ...this.lifeStylePayloadFromStoreObj, annuitantMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions) };
          this.prepareDashBoardList(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
        }
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant' && this.lifeStylePayloadFromStoreObj?.dependentMedicalConditions &&
          this.lifeStylePayloadFromStoreObj.dependentMedicalConditions.length > 0) {
          this.lifeStylePayloadFromStoreObj = { ...this.lifeStylePayloadFromStoreObj, dependentMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions) };
          this.prepareDashBoardList(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions);
        }
        this.getHeaderText();
        this.getNotificationText();
      }
    });

    this.toggleBreadcrumbValues();
    this.clearEditMedIndex();
    this.getWindowSize();
  }

  @HostListener('window:resize', [])
  public onResize() {
    this.detectScreenSize();
  }
  private detectScreenSize() {
    this.deviceType=this.deviceDimensionsService.onResize('$event');
  }

  getWindowSize(): void {
    this.deviceType=this.deviceDimensionsService.onResize('$event');
  }

  // InitializeToolTipForHeader() {
  //   this.medicalConditionConfig = new Tooltip(this.contentData.helpText, '', false);
  // }

  prepareDashBoardList(medCondList: AnnuitantMedicalConditions[]) {
    this.medCondListForDashboard = [];
    let medList = medCondList.filter(medItem => {
      return medItem.questionSetName !== MedicalCondQuestionSet.lifestyle && medItem.questionSetName !== MedicalCondQuestionSet.adl
    });

    if (medList && medList.length > 0) {
      this.isDataPresent = true;
      medList.forEach((element, index) => {
        let temp = new MedCondDashBoard();
        temp.mcName = element.questionSetName;
        temp.status = element.status;
        temp.index = index + 1;
        this.medCondListForDashboard.push(temp);
      });
    } else {
      this.isDataPresent = false;
    }
    if (this.editMode && this.referenceNumber && !this.referenceNumber.isRefreshCard) {
      if (this.isDataPresent) {
        this.userInputDetail.buttonConfig.label = 'Next';
        this.userInputDetail.buttonConfig.name = 'Next';
      } else {
        this.userInputDetail.buttonConfig.label = 'Done';
        this.userInputDetail.buttonConfig.name = 'Done';
      }
    } else {
      if (this.isDataPresent) {
        this.userInputDetail.buttonConfig.label = 'Next';
        this.userInputDetail.buttonConfig.name = 'Next';
      }
    }
    this.syncService.setMCDashboardObj(this.isDataPresent);
  }

  isAllMedConStatusCompleted(): boolean {
    let isStatusIncomplete: boolean = false;
    for (let item in this.medCondListForDashboard) {
      if (this.medCondListForDashboard[item].status === MedicalDashboardStatus.notCompleted) {
        isStatusIncomplete = true;
        break;
      }
    }
    return isStatusIncomplete;
  }

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }   

  editMedicalCondition(item: MedCondDashBoard) {
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'Edit medical condition', name: 'Medical conditions', pageID: this.utilService.getCurrentScreenName() });
    this.healthService.getInitialQuestionContent()
      .subscribe(res => {
        this.syncService.setMCDashboardObj(this.isDataPresent);
        this.utilityServiceForMedicalService.setSelectedMedicalCondition(res.section[0].question[0], item.mcName);
        const tempEditMedIndexModelObj = new EditMedIndexModel();
        tempEditMedIndexModelObj.editIndex = item.index;
        this.syncService.setEditMedConditionIndex(tempEditMedIndexModelObj);
        this.syncService.setEditMode(true);
        if (this.isHOView) {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.DMC, MEDICAL_UW_HO_URL.dependant.dependantDMC)]);
        } else {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.DMC, MEDICAL_UW_URL.dependant.dependantDMC)]);
        }
        this.stagedDataToEdit = null;
      });
  }

  deleteMedicalCondition() {
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Medical conditions', pageID: this.utilService.getCurrentScreenName() });
    this.isDelete = false;
    //console.log('Before Delete->', this.lifeStylePayloadFromStoreObj);
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {

      this.lifeStylePayloadFromStoreObj = {
        ...this.lifeStylePayloadFromStoreObj, annuitantMedicalConditions:
          this.deleteItem(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions, this.itemToDelete)
      }

      // this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions =
      //   this.deleteItem(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions, this.itemToDelete);
      // this.prepareDashBoardList(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
      this.prepareDashBoardList(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
      this.toggleBreadcrumbValues();
      if (this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions.length <= 2) {
        // this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions =
        //   this.deleteAdl(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);

        this.lifeStylePayloadFromStoreObj = {
          ...this.lifeStylePayloadFromStoreObj, annuitantMedicalConditions:
            this.deleteAdl(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions)
        }
      }
      //console.log('after delt anuuitant', this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
    } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      this.lifeStylePayloadFromStoreObj = {
        ...this.lifeStylePayloadFromStoreObj, dependentMedicalConditions:
          this.deleteItem(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions, this.itemToDelete)
      }
      // this.lifeStylePayloadFromStoreObj.dependentMedicalConditions =
      //   this.deleteItem(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions, this.itemToDelete);
      // this.prepareDashBoardList(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions);
      this.prepareDashBoardList(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions);
      this.toggleBreadcrumbValues();
      if (this.lifeStylePayloadFromStoreObj.dependentMedicalConditions.length <= 2) {
        // this.lifeStylePayloadFromStoreObj.dependentMedicalConditions =
        //   this.deleteAdl(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions);

        this.lifeStylePayloadFromStoreObj = {
          ...this.lifeStylePayloadFromStoreObj, dependentMedicalConditions:
            this.deleteAdl(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions)
        }
      }
      //console.log('after delt dependent', this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
    }
    this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    this.store.dispatch(new LifeStyleActions.AddLifestyleResult(this.lifeStylePayloadFromStoreObj));
    //console.log('After Delete->', this.lifeStylePayloadFromStoreObj);
  }

  deleteItem(
    tempMedCondList: AnnuitantMedicalConditions[],
    item: MedCondDashBoard
  ) {
    let medCondList = tempMedCondList.filter(medItem => {
      return medItem.questionSetName !== MedicalCondQuestionSet.lifestyle && medItem.questionSetName !== MedicalCondQuestionSet.adl
    });
    let lifestyleData = [...tempMedCondList.filter(med => { return med.questionSetName === MedicalCondQuestionSet.lifestyle })][0];
    let adlData = [...tempMedCondList.filter(med => { return med.questionSetName === MedicalCondQuestionSet.adl })];
    medCondList.splice(item.index - 1, 1);
    medCondList.unshift(lifestyleData);
    if (adlData && adlData.length > 0) {
      medCondList.push(adlData[0]);
    }
    // let medObj = [];
    // //let medList = [];
    // medCondList.forEach((medCond, i) => {
    //   medObj = {...medCond, index: i};
    // });
    // return medObj;

    let medList: AnnuitantMedicalConditions[] = [];
    medCondList.forEach((medCond, i) => {
      let temp = new AnnuitantMedicalConditions();
      temp.questionSetName = medCond.questionSetName;
      temp.status = medCond.status;
      temp.index = i;
      temp.questions = medCond.questions;
      medList.push(temp);
    });
    return medList;

    // medCondList.forEach((medCond, index) => medCond.index = index);
    //return medCondList;
  }

  // performDelete(tempMedCondList: AnnuitantMedicalConditions[], item: MedCondDashBoard) {
  //   let indexToDelete: number;
  //   let medCondList = [...tempMedCondList];
  //   medCondList.forEach((element, index) => {
  //     if (element.index === item.index) {
  //       indexToDelete = index;
  //     }
  //   });
  //   if (indexToDelete === medCondList[medCondList.length - 1].index) {
  //     let deletedItem = medCondList.splice(indexToDelete, 1);
  //   } else {
  //     let temparray = medCondList.splice(indexToDelete + 1);
  //     let deletedItem = medCondList.splice(indexToDelete, 1);
  //     temparray.forEach(element => {
  //       element = { ...element, index: element.index - 1 };
  //     });
  //     medCondList.push(...temparray);
  //   }
  //   return medCondList;
  // }

  deleteAdl(data) {
    let newArray = data;

    newArray.forEach(element => {
      if (element.questionSetName === MedicalCondQuestionSet.adl) {
        let tempArray = [];
        tempArray = newArray.splice(0, 1);
        newArray = tempArray;
      }
    });
    // this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions = tempArray;
    return newArray;
  }

  userFormData = () => {
    // this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  addMedicalCondtion() {
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Add medical condition', pageID: this.utilService.getCurrentScreenName() });
    if (this.editMode) {
      this.eventType = 'add';
      this.toggleRefreshModal();
    } else {
      this.clearBackData();
      if (this.isHOView) {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.AMC, MEDICAL_UW_HO_URL.dependant.dependantAMC)]);
      } else {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.AMC, MEDICAL_UW_URL.dependant.dependantAMC)]);
      }
    }
  }

  getHeaderText() {
    if (this.isDataPresent) {
      this.headerText = this.contentData.secHeaderText;
      // return this.headerText;
    } else {
      this.headerText = this.contentData.headerText;
      // return this.headerText;
    }
  }

  getNotificationText() {
    if (this.isDataPresent) {
      this.notifStatement = this.contentData.noteStatement;
      // return this.notifStatement;
    } else {
      this.notifStatement = this.contentData.secNoteStatment;
      // return this.notifStatement;
    }
  }

  toggleBreadcrumbValues(): void {
    if (this.isDataPresent) {
      if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
        this.utilService.refreshBreadcrumb({ hideADL: false });
      } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
        this.utilService.refreshBreadcrumb({ hideDepADL: false });
      }
    } else {
      if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
        this.utilService.refreshBreadcrumb({ hideADL: true });
      } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
        this.utilService.refreshBreadcrumb({ hideDepADL: true });
      }
    }
  }

  saveAfterLogin() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully()
    );
  }
  saveAfterLogout() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }

  gotoNextPage() {
    if (this.editMode && this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
      this.referenceNumber = {...this.referenceNumber, editMode: false};
      this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
      this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
      this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
      this.editMode = false;
    } else {
      if (this.isAllMedConStatusCompleted()) {
        this.isIncomplete = true;
      } else if (this.isHOView) {
        // tslint:disable-next-line: max-line-length
        this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.ADL, MEDICAL_UW_HO_URL.dependant.dependantADL)]);
        }
        );
      } else {
        this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.ADL, MEDICAL_UW_URL.dependant.dependantADL)]);
        }
        );
      }
    }

  }

  closeStatusModal() {
    this.isIncomplete = false;
  }

  ngOnDestroy() {
    if (this.lifeStyleFromStoreObsSubscription) {
      this.lifeStyleFromStoreObsSubscription.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }

  clearBackData() {
    const tempBackDataStoreModelObj = new BackDataStoreModel();
    tempBackDataStoreModelObj.currentIndex = null;
    tempBackDataStoreModelObj.isEdit = null;
    tempBackDataStoreModelObj.selectedMedCondn = "";
    //console.log("tempBackDataStoreModelObj Diabetes Screen", tempBackDataStoreModelObj);
    this.syncService.setBackNavData(tempBackDataStoreModelObj);
  }

  clearEditMedIndex() {
    const tempEditMedIndexModelObj = new EditMedIndexModel();
    tempEditMedIndexModelObj.editIndex = null;
    this.syncService.setEditMedConditionIndex(tempEditMedIndexModelObj);
  }

  onSkip() {
    this.isSkip = true;
  }

  navToDoctorDetails() {
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: "Don't have medical condition", pageID: this.utilService.getCurrentScreenName() });
    this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
      if (this.isHOView) {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.doctorDetails, MEDICAL_UW_HO_URL.dependant.dependantDoctorDetails)]);
      } else {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.doctorDetails, MEDICAL_UW_URL.dependant.dependantDoctorDetails)]);
      }
    });
    // }
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_MedicalConditions;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the healthData object values with CMSData object values */
        this.contentData.header = this.CMSData.string_MedicalConditionsTitle;
        this.contentData.headerText = this.CMSData.string_MedicalConditionsSubtitleNoConditions;
        this.contentData.secHeaderText = this.CMSData.string_MedicalConditionsSubtitleConditions;
        this.contentData.subTitle = this.CMSData.string_AddMedicalConditionTitle;
        this.contentData.buttonText = this.CMSData.string_SkipNoMedicalConditionsWarningAddMedicalConditionCTALabel;
        this.contentData.helpText = this.CMSData.string_MedicalConditionsSubtitleInformationWording;
        this.medicalConditionConfig = new Tooltip(this.contentData.helpText, '', false);
        this.skipModalConfig = new AlertModal("alert",
          this.CMSData.string_SkipNoMedicalConditionsWarningTitle,
          this.CMSData.string_SkipNoMedicalConditionsWarningBody,
          this.CMSData.string_SkipNoMedicalConditionsWarningAddMedicalConditionCTALabel,
          this.CMSData.string_SkipNoMedicalConditionsWarningNoMedicalConditioCTALabel, "");
        this.deleteModalConfig = new AlertModal("alert",
          this.CMSData.string_DeleteMedicalConditionWarningTitle,
          this.CMSData.string_DeleteMedicalConditionWarningText,
          this.CMSData.string_DeleteMedicalConditionWarningCTALabelDelete,
          this.CMSData.string_DeleteMedicalConditionWarningCTALabelCancel, "");
        this.statusModalConfig = new AlertModal("alert",
          this.CMSData.string_MedicalConditionsIncompleteTitle,
          this.CMSData.string_MedicalConditionsIncompleteWording,
          this.CMSData.string_OKCTALabel,
          "", "");
        this.contentData.noteStatement = this.CMSData.string_MedicalConditionsStatusIntroduction + this.CMSData.string_MedicalConditionsCompleteWording;
        this.contentData.secNoteStatment = this.CMSData.string_PermissionWording;
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          this.contentData.header = this.CMSData.string_DependatsMedicalConditionsTitle;
          this.contentData.headerText =
            this.CMSData.html_DependantsMedicalConditionsSubtitleNoConditions.replace(/<p/gm, '<p class="dependent-subTitle"');
        }
        //console.log('changed value = ', this.contentData);
        this.getHeaderText();
      }
    });
  }
  /** End of code block for CMS */

  navToAMC() {
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Add medical condition', pageID: this.utilService.getCurrentScreenName() });
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.AMC, MEDICAL_UW_HO_URL.dependant.dependantAMC)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.AMC, MEDICAL_UW_URL.dependant.dependantAMC)]);
    }
    // }
  }

  closeSkip() {
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Close Add medical condition', pageID: this.utilService.getCurrentScreenName() });
    this.isSkip = false;
  }

  cancel() {
    this.isDelete = false;
  }

  medCondnInfoReceiver(value) {
    let config;
    this.analyticsService.eventTrack({ type: 'Question', name: value, pageID: this.getCurrentScreenURL() });
    config = this.medicalConditionConfig;
    this.tooltipModal.content = config.content;
    this.displayTooltipAlert = true;
  }

  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }

  delete(data: MedCondDashBoard) {
    if (this.editMode) {
      this.eventType = 'delete';
      this.stagedDataToEdit = data;
      this.toggleRefreshModal();
    } else {
      this.itemToDelete = data;
      this.isDelete = true;
      this.stagedDataToEdit = null;
    }
  }

  getLifestyleRange() {
    this.healthService.getRangeValidation()
      .subscribe(res => {
        this.rangeValidationData = res.values;
        this.syncService.setRangeValidationJson(this.rangeValidationData);
      });
  }
  alertPrimaryBtnClickinModal() {
    this.editMode = false;
    if (this.eventType && this.eventType === 'add') {
      this.addMedicalCondtion();
    } else if (this.eventType && this.eventType === 'delete') {
      this.delete(this.stagedDataToEdit);
    }
    this.utilService.resetEditModeMU();
    this.toggleRefreshModal();
    this.eventType = null;
  }
  toggleRefreshModal() {
    this.showModalForCardRefresh = !this.showModalForCardRefresh;
  }
  alertSecondaryCardRefreshBtnClick() {
    this.toggleRefreshModal();
    this.eventType = null;
  }
  closeCardRefreshModal() {
    this.toggleRefreshModal();
    this.eventType = null;
  }
  closeModal(){
    this.displayTooltipAlert = false;
  }
}
